import type { FaireProductEntity } from "../../entity_types/product";

export const p_yc7z5awznb: FaireProductEntity = {
  token: "p_yc7z5awznb",
  type: "product",
  name: "Orizuru Porcelain Tayo Medium Bowl – 6 in. Round, 19 oz JP",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/69c337082d6b6070e10dee69ad78d673f9747a2174f0dac32eacc3d354c6fb82.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f51c393f5cf64fe967d83cb4e556ce01cfcf5577856db89fab833baa6fac7ef2.jpeg",
    "https://cdn.faire.com/fastly/05c6a96e396de299df11ddc2ac79b1ea9fc0409fefbae1d0b00e6423a668efe6.jpeg",
    "https://cdn.faire.com/fastly/4f321cf95780e6b90b070fc2ffed1a3f9711b7856aaca73591d34ae73f6246b3.jpeg",
    "https://cdn.faire.com/fastly/b3ca7ad764ff41bd4c92a32d04f60ba4c686cff8ff9ef608768cb6aa0befc137.jpeg",
    "https://cdn.faire.com/fastly/39a87571263e0324489c8f1333bbf49e6e307f32e4c7841defc4730c8a32fbc4.jpeg"
  ],
  priceDollars: 3.5,
  description: "Bring a refined, restaurant-ready look to the table with this 6\" tayo medium bowl in the Orizuru design. A multipurpose bowl for rice bowls, soups, salads, noodles and side dishes. Made in Japan from durable porcelain, it is built for busy restaurants, sushi bars, ramen shops, cafés and catering, while looking just as good on the family dinner table.\n\nFeatures\n\n * Quality porcelain: a classic glazed finish for everyday restaurant and home use \n * Easy care: microwave and dishwasher safe \n * Coordinated collection: mix with other Tayo medium bowl designs, rice bowls and ramen bowls for a coordinated or mix-and-match table setting \nSpecifications\n\n * Size: 6\" Dia x 2.75\" H \n * Capacity: 19 fl oz \n * Material: Porcelain \n * Series: Tayo \n * Design: Orizuru \n * Inner pack: 6 \n * Case pack: 48 \n * Origin: Japan \n * Care: Microwave and dishwasher safe. ",
  tags: [],
  msrpDollars: 7.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:52.419Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
